import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountRequest, AuthService, Profile } from '../../../services/Auth/auth.service';
import { CsvDownloadComponent } from "../../UI/csv-download/csv-download.component";

@Component({
    selector: 'app-dashboard-all-accounts',
    imports: [
        CommonModule,
        RouterModule,
        CsvDownloadComponent
    ],
    templateUrl: './dashboard-all-accounts.component.html',
    styleUrl: './dashboard-all-accounts.component.scss'
})
export class DashboardAllAccountsComponent {

    public incompleteList: Profile[] = []
    public activeList: Profile[] = []
    public activeListCsv: any[] = []
    public pending: AccountRequest[] = []

    constructor(
        public authService: AuthService
    ) {
        this.authService.getLatestRequests().subscribe(data => {
            this.pending = data
        })

        this.authService.getNewProfiles().subscribe(data => {
            let filtered = data.filter(item => {
                let found = false
                this.pending.forEach(pendingItem => {
                    if (pendingItem.id == item.id) {
                        found = true
                    }
                })
                return !found
            })

            this.incompleteList = filtered


        })

        // this.authService.getActiveProfiles().subscribe(data => {

        //     this.activeList = data
        //     this.activeListCsv = this.activeList.map(item => item.getCSV())
        // })
        this.authService.getAllActiveProfiles1().subscribe({
            next: (data) => {
                this.activeList = data;
                this.activeListCsv = this.activeList.map(item => item.getCSV());
            },
            error: (err) => {
                console.error('Error fetching profiles:', err);
            }
        });

    }

    deleteProfile(profile: Profile) {
        this.authService.deleteProfile(profile)
    }

    onAllClick() {
        this.authService.getAllActiveProfiles1().subscribe({
            next: (data) => {
                this.activeList = data;
                this.activeListCsv = this.activeList.map(item => {
                    // console.log(item)
                    return item.getCSV()
                });
            },
            error: (err) => {
                console.error('Error fetching profiles:', err);
            }
        });
    }
}
